import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@/assets/main.css';
import { canAccess } from './utils/permission';
import api from './api/axios.js';
import Toast, { useToast } from 'vue-toastification';
import "vue-toastification/dist/index.css";

// Create the Vue app
const app = createApp(App);

// Configure Axios


// Configure Toast
const toastOptions = {
  position: "top-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true
};

// Use plugins
app.use(router);
app.use(store);
app.use(Toast, toastOptions);

// Global properties
app.config.globalProperties.$api = api;

// Add toast functions using the Vue-Toastification API
const toast = app.config.globalProperties.$toast = {};
const toastInstance = useToast();

toast.success = (message) => toastInstance.success(message);
toast.error = (message) => toastInstance.error(message);
toast.info = (message) => toastInstance.info(message);
toast.warning = (message) => toastInstance.warning(message);

// Add format helpers
app.config.globalProperties.$formatDate = (dbDate) => {
    if (!dbDate) return 'N/A';
    const date = new Date(dbDate);
    return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
};

app.config.globalProperties.$formatDateTime = (dbDateTime) => {
    if (!dbDateTime) return 'N/A';
    const date = new Date(dbDateTime);
// Add this to the end of your main.js file where you set up global properties

// Add helper to skip loader for specific requests
app.config.globalProperties.$apiWithoutLoader = function(method, ...args) {
  if (!this.$api || !this.$api[method]) {
    console.error(`Method ${method} not found on API`);
    return Promise.reject(new Error(`Method ${method} not found on API`));
  }
  
  // Create config with skipLoader flag if it's an object
  if (args.length > 1 && typeof args[1] === 'object') {
    args[1] = { ...args[1], skipLoader: true };
  } else if (args.length === 1) {
    // Add config object with skipLoader if none exists
    args.push({ skipLoader: true });
  }
  
  return this.$api[method](...args);
};
    const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
        `${date.getDate().toString().padStart(2, '0')}/` +
        `${date.getFullYear()}`;

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const paddedHour = hours.toString().padStart(2, '0');

    const formattedTime = `${paddedHour}:${minutes} ${ampm}`;

    return `${formattedDate} ${formattedTime}`;
};

app.config.globalProperties.$canAccess = (routeName) => {
    const userRole = store.getters.getUser?.role || 'guest';
    return canAccess(routeName, userRole, router);
};

app.config.globalProperties.$convertTo12Hour = (time) => {
    if (!time) return '';
    let [hours, minutes] = time.split(":");
    hours = parseInt(hours);
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12 for AM
    let paddedHours = String(hours).padStart(2, '0');
    return `${paddedHours}:${minutes} ${ampm}`;
};

// Mount app
app.mount('#app');
